import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";
import FileUploadField from "../../../Common/FileUploadField";

export default function DocumentVerificationSection({
  employeeData,
  handleInputChange,
  errors,
  photoLoad,
  deleteFile,
  isDisabled = false,
}) {
  return (
    <div
      className="bg-white p-4 shadow pb-5 rounded-3"
      style={{
        marginTop: "4rem",
        marginLeft: "0.8rem",
        marginRight: "0.8rem",
        marginBottom: "4rem",
      }}
    >
      {/* Section Heading */}
      <h4
        className="text-capitalize mb-4"
        style={{ fontFamily: "ErasDemiITC", color: "#2f4766" }}
      >
        Document Verification
      </h4>

      <div
        className="multisteps-form__content"
        style={{ fontFamily: "Calibri" }}
      >
        <Row>
          {/* Aadhar */}
          <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="adhar_upload" style={{ color: "#334d6e" }}>
                Upload Aadhar Card
              </Form.Label>
              <FileUploadField
                name="adhar"
                value={employeeData.adhar}
                onChange={(e) => handleInputChange(e, "employee")}
                onDelete={() => deleteFile("adhar")}
                error={errors?.adhar}
                isLoading={photoLoad}
                placeholder={ImagePlaceholder}
                deleteIcon={X}
                isDisabled={isDisabled}
                accept="image/*,application/pdf"
              />
            </Form.Group>
          </Col>

          {/* PAN */}
          <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="pan_upload" style={{ color: "#334d6e" }}>
                Upload PAN Card
              </Form.Label>
              <FileUploadField
                name="pan"
                value={employeeData.pan}
                onChange={(e) => handleInputChange(e, "employee")}
                onDelete={() => deleteFile("pan")}
                error={errors?.pan}
                isLoading={photoLoad}
                placeholder={ImagePlaceholder}
                deleteIcon={X}
                isDisabled={isDisabled}
                accept="image/*,application/pdf"
              />
            </Form.Group>
          </Col>

          {/* Passport */}
          <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label
                htmlFor="passport_upload"
                style={{ color: "#334d6e" }}
              >
                Upload Passport
              </Form.Label>
              <FileUploadField
                name="passport"
                value={employeeData.passport}
                onChange={(e) => handleInputChange(e, "employee")}
                onDelete={() => deleteFile("passport")}
                error={errors?.passport}
                isLoading={photoLoad}
                placeholder={ImagePlaceholder}
                deleteIcon={X}
                isDisabled={isDisabled}
                accept="image/*,application/pdf"
              />
            </Form.Group>
          </Col>
        </Row>
        <hr />
      </div>
    </div>
  );
}
